<template>
  <div>
    <FillOutStuInfo
      v-if="pageStatus == 0"
      :baseArr="answerBaseList"
      @submitStuInfo="(data, evalData, meterList) => setPageStatus(1, data, evalData, meterList)"
    />
    <AnswerQuestion
      v-else-if="pageStatus == 1"
      :baseArr="answerBaseList"
      :queryObj="queryObj"
      @submitEvaluate="setPageStatus(2)"
    />
    <SubmitAssessment v-else :baseArr="answerBaseList" />
  </div>
</template>

<script>
import FillOutStuInfo from './components/FillOutStuInfo'
import AnswerQuestion from './components/AnswerQuestion'
import SubmitAssessment from './components/SubmitAssessment'
import { getAction } from '@api/manage'
import Vue from 'vue'
import { TOPIC_RECORD } from '@/store/mutation-types'

export default {
  name: 'StudentAnswer',
  components: {
    FillOutStuInfo,
    AnswerQuestion,
    SubmitAssessment,
  },
  data() {
    return {
      pageStatus: Vue.ls.get(TOPIC_RECORD)?.pageStatus || 0,
      formData: {},
      queryObj: {},
      answerBaseList: [],
    }
  },
  created() {
    // this.queryObj = this.$router.history?.current?.query
    this.queryObj = Vue.ls.get(TOPIC_RECORD)?.queryRecord || {}
    if (this.queryObj?.id) {
      this.getTopicRecord()
    }
  },
  methods: {
    setDefaultGrade(record) {
      this.$set(this.formData, 'gradeId', record[0].value)
      this.currGradeName = record[0].title
    },
    setPageStatus(status, data = null, evalData = null, meterList = null) {
      this.pageStatus = status
      if (meterList && Object.keys(meterList).length) {
        this.answerBaseList = meterList
        console.log('answerBaseList1', this.answerBaseList)
      }
      if (status == 1) {
        const recordObj = (evalData && { queryRecord: evalData }) || Vue.ls.get(TOPIC_RECORD) || {}
        const storeObj = { ...recordObj, stuData: data, pageStatus: status }
        Vue.ls.set(TOPIC_RECORD, storeObj)
      }
    },
    getTopicRecord() {
      getAction('/schoolEvaluationPlan/getEvaluationByPlanId', { planId: this.queryObj.id }).then(
        (res) => {
          if (res.success) {
            this.answerBaseList = res.result
            console.log('answerBaseList2', this.answerBaseList)
          }
        }
      )
    },
  },
}
</script>
<style scoped lang="less"></style>
